import { useId } from 'react';
import { hash_cyrb53 } from '@digital-spiders/misc-utils';
import * as styles from './EdgeCut.module.scss';

interface Props {
  sideHorizontal: 'left' | 'right';
  sideVertical: 'top' | 'bottom';
  widths: {
    default: string;
    [key: string]: string;
  };
  hoverClassName?: string;
  className?: string;
}

const EdgeCut = (props: Props) => {
  const { sideHorizontal, sideVertical, widths, className, hoverClassName } = props;

  const isLeft = sideHorizontal === 'left';
  const isTop = sideVertical === 'top';

  const triangleClassBase = 'c' + hash_cyrb53(useId(), { format: 'hex' }).slice(0, 4);

  const defaultWidth = widths.default || '100px';

  const mediaQueries = Object.keys(widths)
    .filter(key => key !== 'default')
    .map(
      key => `
        @media (min-width: ${key}px) {
          ${hoverClassName ? `.${hoverClassName}:hover .${triangleClassBase}` : `.${triangleClassBase}`} {
            --triangle-width: ${widths[key]};
          }
        }
      `,
    );

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            ${hoverClassName ? `.${hoverClassName}:hover .${triangleClassBase}` : `.${triangleClassBase}`} {
              --triangle-width: ${defaultWidth};
            }
            ${mediaQueries.join('\n')}
          `,
        }}
      ></style>
      <div
        className={`${className} ${styles.edgeCutComponentContainer} ${isLeft ? styles.left : styles.right} ${
          isTop ? styles.top : styles.bottom
        } ${triangleClassBase}`}
      ></div>
    </>
  );
};

export default EdgeCut;
